import "./public.scss";
import { Outlet } from "react-router-dom";
import HeaderReservationComponent from "src/components/header-reservation";
import FooterComponent from "src/components/footer";
import ScrollToTopComponent from "src/components/scroll-to-top";

function PublicReservationLayout() {
  return (
    <div className="PublicReservationLayoutStyle">
      <HeaderReservationComponent />
      <Outlet />
      <FooterComponent />
      <ScrollToTopComponent />
    </div>
  );
}

export default PublicReservationLayout;
